module.exports = __webpack_public_path__ + "img/jiax5.844d1347.png";